import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Base UI は className に状態関数を渡せるため、cn() で潰さずに合成する
export function withBase<State>(
  base: string,
  className?: string | ((state: State) => string | undefined),
) {
  return typeof className === 'function'
    ? (state: State) => cn(base, className(state))
    : cn(base, className);
}
